export const SEARCH_SPLIT_REGEX = /[\s+/-]/g;

export const DROPDOWN_SEARCH_DEFAULT_MAX_LENGTH = 200;

// Sentinel value assigned to the pinned "Clear selection" Select.Item so it
// participates in Radix's roving focus / typeahead. Intercepted in
// DropdownTreeSingleSelect's onValueChange before reaching the consumer.
export const DROPDOWN_CLEAR_SENTINEL_VALUE = '__dropdown_tree_clear__';

/**
 * Delay before restoring focus after collapse.
 * 300ms matches `accordion-slide-*` in container/tailwind.config.js, plus 50ms
 * buffer because the timeout is scheduled after React state updates, not when
 * the CSS animation starts. Not used on expand — immediate focus is enough there.
 */
export const ACCORDION_TOGGLE_ANIMATION_MS = 350;
